import { OnInit, Component, ViewChild, ElementRef } from '@angular/core';
import { CustomerService } from '../services/customer.service';
import { FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
import { NgProgress } from 'ngx-progressbar';
import { Modal } from 'ngx-modal';
import { environment } from '../../../environments/environment';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { BonusReissueResponse } from '../interface/bonus-reissue-response.interface';
import { SearchSettingsModal } from '../models/searchSettings-modal';
import { CommonService } from '../../shared/services/common.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-bonus-reissue-tickets',
    templateUrl: '../templates/template1/views/bonus-reissue-tickets.component.html',
    styleUrls: [
        '../templates/template1/themes/default/css/ticket.less',
        '../templates/template1/themes/default/css/bonus-reissue-tickets.component.less']
})
export class BonusReissueTicketsComponent implements OnInit {
    uploader: any;
    fileUploadedResponse: BonusReissueResponse;
    searchComponentSettings: SearchSettingsModal;
    
    @ViewChild('uploadResponseTemplate') uploadResponseTemplate: Modal;
    @ViewChild('fileSelect') fileUploader: ElementRef;

    constructor(
        private _customerService: CustomerService,
        private ngProgress: NgProgress,
        private _commonService: CommonService,
        private _translatePipe: TranslateService
    ) { }

    ngOnInit(): void {
        this.uploader = this._customerService.getUploaderConfig();
        this.searchComponentSettings = new SearchSettingsModal(5, 0);
        this.uploader.onErrorItem =
            (item: any, response: any, status: any, headers: any) => this.onErrorItem(item, response, status, headers);
        this.uploader.onSuccessItem =
            (item: any, response: any, status: any, headers: any) => this.onSuccessItem(item, response, status, headers);
    }

    /**
     * failed to upload file
     * @param item
     * @param response
     * @param status
     * @param headers
     */
    onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
        this.ngProgress.done();
    }
    /**
     * On Successful upload of file
     * @param item
     * @param response
     * @param status
     * @param headers
     */
    onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
        if (response) {
            const res = JSON.parse(response);
            if (res && res.uuid && res.success && res.status == "COMPLETED") {
                this.successTicketUpload(res);
            }else{
                this.searchComponentSettings = new SearchSettingsModal(10, 0);
                this.ticketUploadPollingCallCheck(res);
            }
        }
    }

    /**
     * successful file upload response process
     * 
     * @param res 
     */
    private successTicketUpload(res: BonusReissueResponse){
        if (res && res.uuid && res.success) {
            this.fileUploadedResponse = res;
            this.fileUploadedResponse.url = ApiUrlConstants.customerServiceApiUrl + 'ticket-upload-log/download?key='
            + this.fileUploadedResponse.uuid;
            this.uploadResponseTemplate.open();
            this.uploadResponseTemplate.closeOnOutsideClick = false;
        }
        this.ngProgress.done();
    }

    /**
     * Process the resposne and check whether the file upload pooling process need to be continued are not.
     * 
     * @param response 
     */
    private ticketUploadPollingCallCheck(response: BonusReissueResponse){
        if ((response.status === "IN_PROGRESS") || (response.status === "QUEUED")) {
            if (this.searchComponentSettings.pollCount < this.searchComponentSettings.maxPollCount) {
                this.searchComponentSettings.pollCount = this.searchComponentSettings.pollCount + 1;
                setTimeout(() => {
                    this.getTicketFileUploadePollingRespons(response.uuid);
                }, 1000);
            }
            else {
                const message: any = this._translatePipe.get('ticketing-system.File Upload process got error');
                this._commonService.setNotification('', message.value, 'error', 0, true, 30);
            }
        }
    }

    /**
     * get Polling response
     * 
     * @param url 
     */
    private getTicketFileUploadePollingRespons(url?: string) {
        this._customerService.getTicketUploadFileStatus(url).subscribe((response: BonusReissueResponse) => {
            if (response && response.uuid && response.success) {
                if (response.status === "COMPLETED") {
                    this.successTicketUpload(response);
                } else {
                    this.ticketUploadPollingCallCheck(response);
                }
            }
        }, error => {
            const message: any = this._translatePipe.get('ticketing-system.File Upload process got error');
                this._commonService.setNotification('', message.value, 'error', 0, true, 30);
        });
    }

    /**
     * @description on select file
     * onSelectFile()
     * @memberof BonusReissueTicketsComponent
    */
    onSelectFile(file: any): void {
        if (this.uploader.queue.length && this.uploader.queue.length > 1) {
            this.uploader.queue[0].remove();
        }
        this.fileUploadedResponse = null;
    }

    /**
     * @description upload bonus reissue tickets files
     * uploadBonusReissueTicketsFile()
     * @memberof BonusReissueTicketsComponent
    */
    uploadBonusReissueTicketsFile(): void {
        if (this.uploader.queue && this.uploader.queue.length) {
            this.ngProgress.start();
            this.uploader.onBuildItemForm = (item: any, form: any) => {
                item.withCredentials = false;
                item.uploader.authToken = this._customerService.getAuthorizationToken();
                form.append('fileName', decodeURIComponent(encodeURIComponent(item.file.name)));
            };
            for (let i = 0; i < this.uploader.queue.length; i++) {
                this.uploader.queue[i].upload();
            }
        }
    }

    /**
     * @description download bonus reissue template
     * downloadDocument()
     * @memberof BonusReissueTicketsComponent
    */
    downloadDocument(path:any) {
        const a = document.createElement('a');
        a.href =environment.uiTemplateBaseUrl+path;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    /**
     * @description clode upload template popup
     * closePopup()
     * @memberof BonusReissueTicketsComponent
    */
    closePopup(): void {
        this.uploadResponseTemplate.close();
        this.fileUploadedResponse = null;
        this.uploader.queue = [];
        this.fileUploader.nativeElement.value = '';
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/bonus-resissue-tickets.component.ts